type OrganizationMemberSettingsPermissions = Record<string, unknown>;

export type OrganizationMemberSettingsActions = {
  editRole: boolean;
  removeMembership: boolean;
};

export function getOrganizationMemberRole<Role extends string>({
  assignedRole,
  organizationOwnerId,
  personId,
}: {
  assignedRole: Role | null | undefined;
  organizationOwnerId: string | null | undefined;
  personId: string | null | undefined;
}): Role | 'owner' | 'player' {
  if (personId && personId === organizationOwnerId) {
    return 'owner';
  }

  if (assignedRole && assignedRole !== 'owner' && assignedRole !== 'player') {
    return assignedRole;
  }

  return 'player';
}

export function getOrganizationMemberSettingsActions({
  isManaged,
  isOwner,
  isSelf,
  permissions,
}: {
  isManaged: boolean | null | undefined;
  isOwner: boolean;
  isSelf: boolean;
  permissions: OrganizationMemberSettingsPermissions | null | undefined;
}): OrganizationMemberSettingsActions {
  const canEditOthers = Boolean(permissions?.edit_others);

  return {
    editRole: canEditOthers && !isManaged && !isOwner && !isSelf,
    removeMembership:
      !isOwner &&
      Boolean(isSelf ? permissions?.delete_self : permissions?.delete_others),
  };
}
